export default __webpack_public_path__ + "static/bg-4cc94357b7370b8c17186968d6b5a06e.jpg";